import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { CartProvider } from 'react-use-cart'

import { MasterInit } from 'src/_metronic/layout/MasterInit'
import { LayoutProvider, LayoutSplashScreen } from 'src/_metronic/layout/core'
import { ThemeModeProvider } from 'src/_metronic/partials'
import { I18nProvider } from 'src/app/modules/i18n/i18nProvider'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Provider as JotaiProvider } from 'jotai'

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import Base from 'src/feature/bite/layout/Base'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-ultimate'

import './style.css'

const queryClient = new QueryClient()

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <ToastContainer />
      <JotaiProvider>
        <QueryClientProvider client={queryClient}>
          <CartProvider>
            <I18nProvider>
              <GoogleReCaptchaProvider
                type='v2-checkbox'
                siteKey={process.env.REACT_APP_CAPTCHA_KEY as string}
              >
                <LayoutProvider>
                  <ThemeModeProvider>
                    <Base>
                      <Outlet />
                      <MasterInit />
                    </Base>
                  </ThemeModeProvider>
                </LayoutProvider>
              </GoogleReCaptchaProvider>
            </I18nProvider>
          </CartProvider>
        </QueryClientProvider>
      </JotaiProvider>
    </Suspense>
  )
}

export { App }
